// @flow
import authApiService from './auth-api-service';
import { ResourceType } from './../types/resource';
import { getTFunction } from '../i18n';

export class ResourceService {
  all(): Promise<ResourceType[]> {
    return authApiService
      .get('/resources')
      .then((response) => response.resources)
      .catch((err) => new Error(err));
  }

  show(id: number): Promise<ResourceType> {
    return authApiService
      .get(`/resources/${id}`)
      .then((response) => response.resource)
      .catch((err) => new Error(err));
  }

  include(id: number, params: string): Promise<ResourceType> {
    return authApiService
      .get(`/resources/${id}/?include=${params}`)
      .then((response) => response.resource)
      .catch((err) => new Error(err));
  }

  exclude(params: string): Promise<ResourceType[]> {
    return authApiService
      .get('/resources?&resource_type=immunization')
      .then((immunizationsResponse: { resources: ResourceType[] }) => {
        return authApiService
          .get(`/resources?&exclude=${params}`)
          .then((restResponse: { resources: ResourceType[] }) => {
            const rest = restResponse.resources.filter((r) => r.resource_type !== 'immunization');
            const allResources = (immunizationsResponse || []).resources.concat(rest || [])
              .filter((r) => !r.draft);
            return allResources;
          })
          .catch((err) => new Error(err));
      })
      .catch((err) => new Error(err));
  }

  files(type: string): Promise<ResourceType[]> {
    const t = getTFunction('errors');
    return authApiService
      .get(`/resources/files?resource_type=${type}`)
      .then((files: File[]) => {
        if (Array.isArray(files)) {
          return files;
        }
        throw new Error(t('frontend.files_not_found'));
      })
      .catch((err) => new Error(err));
  }

  vaccinations(): Promise<> {
    return authApiService
      .get('/vaccines/timeline')
      .then((response) => response && response.vaccinations)
      .catch((err) => new Error(err));
  }
}

export default new ResourceService();



// WEBPACK FOOTER //
// ./src/services/resource-service.js